import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import { AccessControlHistoryDropdownFilterCell } from './AccessControlHistoryDropdownFilterCell';
import { GetString } from '../../StringResourceManager';
import {
  commandStatusTextMap,
  commandStatusToTypeMap,
  getCommandStatusOptions,
} from '../../../utils/textMappings';

export const AccessControlHistoryStatusFilterCell: any = (
  props: GridCustomFilterCellProps,
) => (
  <AccessControlHistoryDropdownFilterCell
    {...props}
    data={getCommandStatusOptions()}
    defaultItem={GetString('SELECT_STATUS')}
    onChangeValueCheckFunc={commandStatusToTypeMap}
    commandStatusTextMap={commandStatusTextMap}
  />
);
